export enum SentGeoStatus {
    Waiting = 0,
    Active = 1,
    Inactive = 2,
    Error = 3,
};
